import { render, staticRenderFns } from "./order.vue?vue&type=template&id=21451923&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=21451923&prod&scoped=true&lang=scss"
import style1 from "./order.vue?vue&type=style&index=1&id=21451923&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21451923",
  null
  
)

export default component.exports